import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import OneVideo from '@/modules/module-oneVideo';
import OneTabSystem from '@/modules/module-oneTabSystem';
import FreshDeskService from '@/views/fresh-desk/service';
import CustomerUtils from '@/utils/customer-utils';
import FlashMessageUtil from '@/utils/flash-message-util';

export default Backbone.View.extend({
  render: async function (opts) {
    console.log('init utility page');

    var self = this;
    self.$body = $('body');
    self.$content = self.$el;
    self.$linksContainer = self.$content.find('.utility-nav .links');
    self.$module404 = self.$content.find('.section-404');
    self.$contactForm = self.$content.find('.contact-form-container');
    self.fobSettings = JSON.parse(localStorage.getItem('fob-settings'));

    self.formFields = [
      { id: 'ContactFormIssue', isValid: false },
      { id: 'ContactFormName', isValid: false },
      { id: 'ContactFormEmail', isValid: false },
      { id: 'ContactFormMessage', isValid: false }
    ];

    self.submitFormButton = document.querySelector('#submitFormButton');
    self.submitFormButton.classList.add('disabled');

    self.initFormListeners();
    self.initTabSystem();
    self.initUtilityNav();

    if (self.$module404.length > 0) {
      self.module404();
    }
    if (self.$contactForm.length > 0) {
      self.contactForm();
    }

    self.handleChatNowAvailability();

    const userEmail = window.marketingUserData.email;
    const userHasActiveSubs = await CustomerUtils.hasActiveSubs(userEmail);

    self.submitFormButton.addEventListener('click', () => {
      if (self.formIsValid()) {
        self.submitFormButton.style.opacity = '0.5';
        self.submitFormButton.style.pointerEvents = 'none';

        const formIssueSelectedOption =
          document.getElementById('ContactFormIssue')?.selectedOptions[0];
        const skipTicketCreation =
          formIssueSelectedOption?.dataset.skipTicket ?? false;
        const apiKeyPlusPass = process.env.API_FRESHDESK_KEY_PLUS_PASS;
        const domain = self.fobSettings.freshdesk_domain;
        const description = document.getElementById('ContactFormMessage').value;
        const email = document.getElementById('ContactFormEmail').value;
        const type = document.getElementById('ContactFormIssue').value;
        const subject = formIssueSelectedOption?.dataset.subject || type;
        const name = document.getElementById('ContactFormName').value;
        const priority = userHasActiveSubs
          ? 3
          : parseInt(formIssueSelectedOption?.dataset.priority, 10) || 0;

        if (skipTicketCreation) {
          self.sendCollaborationRequest(email, name, description);
          this.closeContactModal();
          FlashMessageUtil.showFlashMessage({
            message: `Your collaboration request has been sent successfully!`
          });
        } else {
          new FreshDeskService({ apiKeyPlusPass, domain }).sendTicket({
            description,
            email,
            type,
            name,
            priority,
            subject,
            onSuccess: () => {
              FlashMessageUtil.showFlashMessage({
                message: 'Your message has been sent. Please check your email.'
              });
            },
            onError: () => {
              FlashMessageUtil.showFlashMessage({
                message:
                  'There was an error sending your message. Please try again.',
                error: true
              });
            },
            onFinally: () => {
              this.closeContactModal();
            }
          });
        }
      }
    });
  },

  events: {},

  sendCollaborationRequest: function (email, name, message) {
    const learnq = window._learnq || [];

    learnq.push([
      'identify',
      {
        $email: email
      }
    ]);

    learnq.push([
      'track',
      'Collaboration Request',
      {
        message: message,
        customer_email: email,
        customer_name: name
      }
    ]);
  },

  module404: function () {
    var self = this;
    var $videos = self.$module404.find('.video-wrapper');

    OneVideo.init({
      el: $videos,
      isResponsive: false,
      bgVideo: true,
      autoplay: true
    });
  },

  contactForm: function () {
    var self = this;

    $('body').append(
      $('<div/>', {
        id: 'utility-contact-overlay'
      })
    );

    var $chatTrigger = $('#chat-trigger');
    var $formTrigger = $('#form-trigger');
    var $formClose = $('#form-close');

    $formTrigger.on('click', function () {
      self.clearForm();
      self.$contactForm.removeClass('hidden');
      self.$body.addClass('show-utility-overlay');
    });
    $formClose.on('click', function () {
      self.$contactForm.addClass('hidden');
      self.$body.removeClass('show-utility-overlay');
    });

    $('#utility-contact-overlay').on('click', function () {
      if (!self.$contactForm.hasClass('hidden')) {
        self.$contactForm.addClass('hidden');
        self.$body.removeClass('show-utility-overlay');
      }
    });

    $chatTrigger.on('click', function () {
      if (ORW.enableLiveChat && window.fcWidget?.isOpen() != true) {
        window.fcWidget.open();
      }
    });
  },

  initTabSystem: function () {
    OneTabSystem.init({
      el: $('.utility-content')
    });
  },

  initUtilityNav: function () {
    var self = this;
    var events = {
      'click .utility-nav .select-link': function (e) {
        self.$linksContainer.toggleClass('opened');
      }
    };
    _.extend(self.events, events);
    self.delegateEvents();
  },

  formIsValid: function () {
    var self = this;
    return self.formFields.every((field) => field.isValid);
  },

  clearForm: function () {
    var self = this;
    self.submitFormButton.classList.add('disabled');
    self.formFields.forEach((field) => {
      const inputField = document.querySelector(`#${field.id}`);
      inputField.value = '';
      field.isValid = false;
    });
  },

  onInputChange: function (event, id) {
    var self = this;
    const value = event.target.value.trim();
    const formField = self.formFields.find((field) => field.id === id);
    formField.isValid = value !== '';
    self.submitFormButton.classList.add('disabled');
    if (self.formIsValid()) {
      self.submitFormButton.classList.remove('disabled');
    }
  },

  initFormListeners: function () {
    var self = this;
    self.formFields.forEach(({ id }) => {
      const inputField = document.querySelector(`#${id}`);
      inputField?.addEventListener('input', (event) => {
        self.onInputChange(event, id);
      });
    });
  },

  closeContactModal: function () {
    var self = this;
    const contactFormContainer = document.querySelector(
      '.contact-form-container'
    );
    contactFormContainer?.classList.add('hidden');

    document.body.classList.remove('show-utility-overlay');
    document.getElementById('ContactFormIssue').value = '';
    self.clearForm();

    self.submitFormButton.style.opacity = '1';
    self.submitFormButton.style.pointerEvents = 'all';
  },

  destroy: function () {
    var self = this;
    self.undelegateEvents();
  },

  isMobile: function () {
    if (ORW.responsive == 'small') {
      return true;
    }
    return false;
  },

  handleChatNowAvailability: function () {
    if (!ORW.enableLiveChat) {
      const chatTrigger = document.getElementById('chat-trigger');
      chatTrigger.classList.add('disabled');
    }
  }
});
